export const getInitialClientState = ({ queryOptions, type, id }) => ({
    ...(!!queryOptions ? { queryOptions } : null),
    type,
    id,
    signal: Date.now()
})